var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import api from "shared/api/axios-instance";
import { percentChange } from "shared/lib/format";
export var calculateStats = function (chartData, currentPrice) {
    var _a, _b, _c, _d, _e;
    var day1 = (_b = (_a = chartData.at(-2)) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : currentPrice;
    var day7 = (_d = (_c = chartData.at(-7)) === null || _c === void 0 ? void 0 : _c.price) !== null && _d !== void 0 ? _d : currentPrice;
    var days30 = (_e = chartData[0].price) !== null && _e !== void 0 ? _e : currentPrice;
    return {
        day1: percentChange(day1, currentPrice),
        day7: percentChange(day7, currentPrice),
        day30: percentChange(days30, currentPrice),
    };
};
export var mapTokenToCoin = function (t, balance) {
    var _a, _b, _c;
    if (balance === void 0) { balance = 0; }
    var chartData = ((_a = t.priceHistory) !== null && _a !== void 0 ? _a : []).map(function (p) { return ({ date: p.day, price: p.price }); });
    var currentPrice = (_c = (_b = chartData.at(-1)) === null || _b === void 0 ? void 0 : _b.price) !== null && _c !== void 0 ? _c : 0;
    var upperCaseSymbol = t.symbol.toUpperCase();
    var cleanTitle = upperCaseSymbol === "WBNB" ? "BNB" : upperCaseSymbol;
    return {
        id: t.id,
        icon: t.logoImg,
        title: cleanTitle,
        subtitle: cleanTitle === "BNB" ? "Binance Coin" : t.name,
        stats: calculateStats(chartData, currentPrice),
        owned: balance,
        price: currentPrice,
        prevPrice: currentPrice,
        total: balance * currentPrice,
        chartData: chartData,
    };
};
export var fetchCoinsNew = function () {
    var args_1 = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args_1[_i] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([], args_1, true), Promise, function (userBalances) {
        var res, tokens, balancesMap;
        if (userBalances === void 0) { userBalances = []; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/coin/all")];
                case 1:
                    res = _a.sent();
                    tokens = res.data;
                    balancesMap = new Map(userBalances.map(function (b) { return [b.coinId, parseFloat(b.balance)]; }));
                    return [2 /*return*/, tokens.map(function (t) {
                            var _a;
                            var userBalance = (_a = balancesMap.get(t.id)) !== null && _a !== void 0 ? _a : 0;
                            return mapTokenToCoin(t, userBalance);
                        })];
            }
        });
    });
};
